import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import DataTable from "../../components/Table/DataTable";
import SearchBox from "./../../components/SearchBox/SearchBox";

import { getAsyncTasks } from "../../services/asynctask";
import { showAlert } from "../../store/ducks/alert";

import { CircularProgress } from "@material-ui/core";

const AsyncTasks = (location, match) => {
  const dispatch = useDispatch();
  const [tasks, setTasks] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayAsyncTasks();
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ["key" ,"taskStatus", "taskType", "createdAt", "updatedAt", "userId" ];

  const displayAsyncTasks = async () => {
    try {
      setIsLoading(true);

      let params = {limit: 5}
      if(isSearching) params = {...searchField, ...params};

      const {data: tasks} = await getAsyncTasks(page, params)

      setTasks(tasks.rows);
      setTotalItems(tasks.count);
      setTotalPages(tasks.pages);
      setPage(tasks.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", error.message));
    }
  };

  if (isLoading)
    return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Async Tasks ({totalItems})</h1>

        <SearchBox
          selectItems={headers}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        head={headers}
        body={tasks}
        bodyColumn={headers}
        action={true}
        linkPath={"asynctasks"}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default AsyncTasks;
